module.exports = __webpack_public_path__ + "img/tracking-scan.792c6bc0.svg";